import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AsideContacts from "../../components/AsideContacts";
import AsideNewFeed from "../../components/AsideNewFeed";
import { database } from "../../firebase";
import moment from "moment";
import { css } from "@emotion/react";
import { DotLoader } from "react-spinners";

function Notifications() {
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));

  let uid = "RKZqtLpPE7Qbf7cfo2R5oZQ7j8j2";
  var timenow = moment().format("YYYY-MM-DD HH:m:s");

  function getUserData(uid) {
    return new Promise((resolve, reject) => {
      return database.ref("users/" + uid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }
  function getCreditzNotifications() {
    setLoading(true);

    return database
      .ref(`/Notifications`)
      .child(currentUser.uid)
      .orderByChild("isDeleted")
      .equalTo("false")
      .once("value")
      .then(async (snapshot) => {
        const array = [];
        const keys = [];
        snapshot.forEach((childSnapshot) => {
          array.push(childSnapshot.val());
          keys.push(childSnapshot.key);
        });
        array.reverse();
        var newRes = await Promise.all(
          array.map(async (user) => {
            const sender = await getUserData(user.sender);

            return { notification: user, user_details: sender };
          })
        );
        var addkeys = keys.map((key) => {
          return { ...newRes, key: key };
        });
        setNotifications(addkeys);
        setLoading(false);
      });
  }
  async function deleteNotification(credid) {
    setLoading(true);

    const updates2 = {};
    updates2[`Notifications/${currentUser.uid}/${credid}/isDeleted`] = "true";
    await database.ref().update(updates2);
    await getCreditzNotifications();
    setLoading(false);
  }

  function isRead() {
    notifications.forEach(async (notification) => {
      const updates = {};
      updates[`/Notifications/${currentUser.uid}/${notification.key}/isread`] =
        "true";
      await database
        .ref()
        .update(updates)
        .then(() => {});
    });
  }

  document.title = "Notifications";
  useEffect(() => {
    getCreditzNotifications();
  }, []);

  const getNotificationType = (type, status) => {
    if (type === "Creditz" && status === "Pending") {
      return " Sent you a Creditz Request ";
    } else if (type === "FriendRequest" && status === "Accepted") {
      return " Accepted your Friend Request ";
    } else if (type === "Creditz" && status === "Accepted") {
      return " Accepted your Creditz Request ";
    } else if (type === "DashCredit" && status === "liked") {
      return "Liked your Creditz";
    } else if (type === "Message") {
      return "Sent you a Message";
    }
  };

  useEffect(() => {
    isRead();
  }, [notifications]);

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: purple;
    color: purple;
    opacity: 0.5;
  `;

  let [color] = useState();
  return (
    <>
      {/* Left Aside */}
      <AsideNewFeed></AsideNewFeed>

      <section className="main-content">
        <div className="middle-box">
          <div className="row">
            <div className="col-sm-12 mb-5">
              <div className="card border-0 rounded-xl shadow-xs overflow-hidden mb-3">
                <div className="card-header d-flex align-items-center bg-primary px-4 py-2 fw-bold text-white">
                  <Link
                    to="/Settings"
                    className="d-inline-flex align-middle text-white py-3 pe-4"
                  >
                    <svg className="icon icon-8x">
                      <use href="#icon_arrowback"></use>
                    </svg>
                  </Link>
                  Notifications{" "}
                  <span className="badge ms-3 fs-18 fw-medium bg-red2-gradient">
                    {notifications && notifications.length}
                  </span>
                </div>
              </div>

              <div className="card border-0 rounded-xl shadow-xs">
                <div className="card-body p-md-4">
                  {loading == true ? (
                    <DotLoader
                      color={color}
                      css={override}
                      size={100}
                      color={"#7444C0"}
                    />
                  ) : (
                    notifications &&
                    notifications.map((notif, i) => (
                      <div
                        className="d-flex bg-light-hover p-2 rounded-lg align-items-start mb-2"
                        key={notif.id}
                      >
                        <div className="mmwh-45 overflow-hidden rounded-pill me-3">
                          <img
                            src={
                              notif && notif[i].user_details?.profileImageUrl
                            }
                            className="w-100"
                            alt="user"
                          />
                        </div>

                        <div className="me-auto w-100-m125 align-self-center">
                          <div className="fs-13 mb-1 capitalize">
                            <Link to={`/profile/${notif[i].user_details?.uid}`}>
                              <strong>
                                {notif[i].user_details.fullName + " "}{" "}
                              </strong>

                              {getNotificationType(
                                "" + notif[i].notification.type,
                                notif[i].notification.status
                              )}
                            </Link>
                          </div>
                          <div className="fs-11 fw-semibold text-black-50">
                            {moment(notif[i].notification.timestamp).fromNow()}
                          </div>
                        </div>
                        <div className="ms-auto dropdown">
                          <button
                            type="button"
                            data-bs-toggle="dropdown"
                            className="btn mmwh-35 text-grey bg-light p-0 rounded-pill"
                          >
                            <svg className="icon icon-3x">
                              <use href="#icon_hdots"></use>
                            </svg>
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end border-0 rounded-xl shadow-xs">
                            <li className="my-1">
                              <button
                                className="dropdown-item d-flex align-items-center"
                                type="button"
                                onClick={() => deleteNotification(notif.key)}
                              >
                                <div className="text-muted1 lh-sm">
                                  <svg className="icon fs-22">
                                    <use href="#icon_delete"></use>
                                  </svg>
                                </div>
                                <div className="fw-semibold ms-2">
                                  <div className="fs-12">Delete</div>
                                </div>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Right Aside */}
      <AsideContacts></AsideContacts>
    </>
  );
}

export default withRouter(Notifications);
